// @ts-nocheck
import i18n from 'i18n';
import moment from 'moment-timezone';
import 'moment/min/locales';
import { EDIT_PROFILE } from './../constants';
import { CONSTANTS } from '../services/devicesServices';

// { language: momentLocale }
const momentLocaleMapping: Record<string, string> = {
  'zh-Hans': 'zh-cn',
  'pt': 'pt-br',
  'pt-PT': 'pt',
};

export const getLanguage = () => momentLocaleMapping[i18n.language] || i18n.language || 'en';

const DateUtils = {
  getFormatedStringFromDays: (numberOfDays: any, shortShow: Boolean) => {
    if (Number.isInteger(+numberOfDays)) {
      const years = Math.floor(numberOfDays / 365),
        months = Math.floor((numberOfDays % 365) / 30),
        days = Math.floor((numberOfDays % 365) % 30);
      shortShow = shortShow || true;
      var yearsDisplay =
        years > 0
          ? years + (shortShow ? 'y, ' : years === 1 ? 'year, ' : 'years, ')
          : '';
      var monthsDisplay =
        months > 0
          ? months + (shortShow ? 'm, ' : months === 1 ? 'month, ' : 'months, ')
          : '';
      var daysDisplay =
        days > 0 ? days + (shortShow ? 'd' : days === 1 ? 'day' : 'days') : '';
      return yearsDisplay + monthsDisplay + daysDisplay;
    } else {
      return null;
    }
  },
  // formatDate: (val: String) => {
  //   if (val != null) {
  //     return val.split(' ').reduce((b, c) => {
  //       let temp = c.split('-');

  //       if (temp.length > 1) b += temp[2] + '-' + temp[0] + '-' + temp[1];
  //       else b += 'T' + c;
  //       return b;
  //     }, '');
  //   } else {
  //     return 'not valued';
  //   }
  // },
  formatDate: (date: string, format?: string) => {
    moment.locale(getLanguage());
    let stillUtc = moment.utc(date).toDate();
    return format ? moment(stillUtc).local().format(format) : moment(date).fromNow();
  },
  timetoXbyUTC: (startDate: any, timezone: any) => {
    moment.locale(getLanguage());
    let checkInvalid = moment().to(moment.tz(startDate, timezone));
    if (
      startDate === undefined ||
      startDate === null ||
      startDate === '' ||
      checkInvalid === 'Invalid date'
    ) {
      return null;
    }
    return checkInvalid;
  },
  timetoXbyGMT: (startDate: any) => {
    moment.locale(getLanguage());
    let stillUtc = moment.utc(startDate).toDate();
    let localDate = moment(stillUtc)
      .local()
      .format('YYYY-MM-DD HH:mm:ss');
    return moment().to(localDate);
  },
  countDate: (
    secretKeyExpiredDays: any,
    secretKeyReminderDays: any,
    secretKeyLastestChangeDate: any,
  ) => {
    let reminderDays =
      secretKeyExpiredDays - moment.utc().diff(moment(secretKeyLastestChangeDate), 'days');

    return {
      reminderSecretKeyExpired:
        reminderDays <= secretKeyReminderDays && reminderDays > 0 ? true : false,
      reminderDays: reminderDays,
    };
  },
  getMonthName: (t: TFunction, monthNumber: number): string => {
    return t('common:months', { returnObjects: true })[monthNumber];
  },
  formatDateTime(date: string, dateFormat: string = "MMM DD, YYYY", timeFormat: string | false = "hh:mm A") {
    moment.locale(getLanguage());
    const diffDay = moment.utc().diff(moment.utc(date), 'days');
    const timeParam = localStorage.getItem(EDIT_PROFILE.TIME_FORMAT_SETTING);
    if(timeParam === '24' && timeFormat !== false){
      timeFormat = 'HH:mm'
    }
    
    let stillUtc = moment.utc(date).toDate();
    let localDate = moment(stillUtc).local();

    return diffDay < 1
      ? moment().to(localDate)
      : moment(stillUtc)
          .local()
          .format(`${dateFormat} ${timeFormat ? `${timeFormat}` : ''}`);
  },
  formatDateOfDeviceConfig(device: any) {
    moment.locale(getLanguage());
    return {
      ...device,
      configuration: {
        ...device.configuration,
        since: device.configuration.since !== CONSTANTS.NOT_APPLICABLE ? this.formatDate(device.configuration.since, 'MMMM YYYY') : device.configuration.since,
        lastActive: device.configuration.lastActive !== CONSTANTS.NOT_APPLICABLE ? this.timetoXbyGMT(device.configuration.lastActive) : device.configuration.lastActive,
      }
    }
  },
  formatDateOfDelegation(date: string, dateTimeFormat: string = "ddd DD MMMM, YYYY HH:mm", timezone?: any){
    moment.locale(getLanguage());
      if(!!timezone){
        let dateTime = moment(date).format(dateTimeFormat)
        if(
          dateTime === undefined ||
          dateTime === null      ||
          dateTime === 'Invalid date'
          ) { return ''}
        let length = dateTime.length;
        let sign = dateTime.charAt(length-6)
        let timezone = dateTime.substring(length-5, length);
        return `${dateTime.substring(0,length-7)} (UTC${sign}${timezone})` 
      }else{
        let dateTime = moment(date).format(dateTimeFormat)
        if(
          dateTime === undefined ||
          dateTime === null      ||
          dateTime === 'Invalid date'
          ) { return ''}
        return dateTime
      }
    
  },
  formatDateTimePicker(date: string, dateTimeFormat: string = "ddd DD MMMM, YYYY"){
    moment.locale(getLanguage())
    let dateTime = moment(date).format("ddd DD MMMM, YYYY HH:mm")
    return moment(dateTime, dateTimeFormat)
  },
  getDateTimeFromString(startDateTimeData, endDateTimeData){
   if(!!startDateTimeData && !!endDateTimeData){
    let startDate, endDate, length
    startDate = startDateTimeData.trim() 
    endDate = endDateTimeData.trim() 
    length = startDateTimeData.length;
    let newStartTime = startDate.substring(length-8, length-3);
    let newStartDate = startDate.substring(0,length-3)
      length = endDateTimeData.length
    let newEndTime = endDate.substring(length-8, length-3)
    let newEndDate = endDate.substring(0,length-3)
    return {
      newStartTime,
      newEndTime,
      newStartDate,
      newEndDate,
    }
   }
  },
  sortArrayByDateProperty(array = [], property, ascendingOrder = false) {
    if (array.length) { 
      return array.sort((element1, element2) => {
        const date1 = new moment(element1[property], 'YYYY-MM-DD HH:mm:ss').valueOf();
        const date2 = new moment(element2[property], 'YYYY-MM-DD HH:mm:ss').valueOf();
        const a = isNaN(date1) ? 0 : date1;
        const b = isNaN(date2) ? 0 : date2;
        return ascendingOrder ? a - b : b - a;
      })
    }
    return array;
  },
};
export default DateUtils;
